export function entityDetails(state) {
  return function (stateName) {
    return state[stateName];
  };
}